angular.module('List').controller('IndicatorTypeListController', [
    '$scope',
    'DataService',
    function ($scope, DataService) {
        $scope.loading = true;
        $scope.loadList = function() {
            var cache = localStorage.getItem('hyperionIndicatorTypeList')
            if(cache) {
                var data = JSON.parse(cache);
                $scope.setData(data);
            } else {
                DataService.indicatorTypeList()
                    .then(function (data) {
                        $scope.setData(data);
                    });
            }
        };

        $scope.setData = function(data) {
            $scope.indicatorTypes = data['types'];
            $scope.loading = false;
        };
}]);
